import React from 'react';
import { icons } from '../../utils/svgPaths';
import './AboutPage.css';

// ── Nuestra Historia ──────────────────────────────────────────────────────────
function OurHistory() {
  return (
    <section className="history-section">
      <div className="history-inner">
        {/* Title with heart icon */}
        <div className="history-title-row">
          <svg width="32" height="32" viewBox="0 0 36 36" fill="none">
            <path d={icons.heart} stroke="#466045" strokeWidth="2" fill="none" />
          </svg>
          <h2 className="history-h2">Nuestra Historia</h2>
        </div>
        {/* Text content */}
        <div className="history-texts">
          {[
            'En Gemelas Villalobos Muñoz contamos con más de 18 años de experiencia en confección y bordado profesional en Costa Rica. Nos especializamos en transformar ideas en prendas que reflejan identidad, profesionalismo y calidad.',
            'Cada pieza que elaboramos está hecha con dedicación, detalle y altos estándares de acabado, porque creemos que una prenda bien confeccionada no solo viste… representa.',
            'Trabajamos con instituciones educativas, empresas, equipos deportivos y clientes particulares que buscan calidad, responsabilidad y cumplimiento.',
          ].map((text, i) => (
            <p key={i} className="history-p">{text}</p>
          ))}
        </div>
      </div>
    </section>
  );
}

// ── Vision ────────────────────────────────────────────────────────────────────
function Vision() {
  return (
    <section className="vision-section">
      <div className="vision-inner">
        {/* Image */}
        <img
          src="/images/fabrics.jpeg"
          alt="Visión"
          className="vision-img"
        />
        {/* Text */}
        <div className="vision-text">
          <h2 className="vision-h2">Vision</h2>
          <p className="vision-p">
            Brindar productos de confección y bordado de alta calidad que superen las expectativas de nuestros clientes, aportando profesionalismo, responsabilidad y pasión en cada proyecto.
          </p>
          <button className="vision-btn">Conoce nuestro equipo</button>
        </div>
      </div>
    </section>
  );
}

// ── Mission ───────────────────────────────────────────────────────────────────
function Mission() {
  return (
    <section className="mission-section">
      <div className="mission-inner">
        {/* Text */}
        <div className="mission-text">
          <h2 className="mission-h2">Mision</h2>
          <p className="mission-p">
            Ser una empresa líder en confección y bordado en la zona de Orotina y expandir nuestra presencia a nivel nacional, destacándonos por nuestra calidad, innovación y compromiso con cada cliente.
          </p>
        </div>
        {/* Image */}
        <img
          src="/images/machine.jpeg"
          alt="Misión"
          className="mission-img"
        />
      </div>
    </section>
  );
}

// ── Personal / Quote ──────────────────────────────────────────────────────────
function PersonalQuote() {
  return (
    <section className="quote-section">
      <div
        className="quote-card"
      >
        {/* Profile image */}
        <img
          src="/images/twings.jpeg"
          alt="Gemelas Villalobos"
          className="quote-img"
        />

        {/* Quote text */}
        <div className="quote-text">
          <p className="quote-p">
            En Gemelas Villalobos Muñoz no solo confeccionamos prendas… construimos confianza, identidad y profesionalismo en cada puntada.
          </p>
        </div>

        {/* Contact card overlay */}
        <div
          className="quote-contact-card"
        >
          <p className="quote-contact-name">Gemelas Villalobos</p>
          <p className="quote-contact-sub">
            ¿Necesitas uniformes, bordados o confección personalizada? Estamos listas para ayudarte.
          </p>
        </div>
      </div>
    </section>
  );
}

// ── Page Export ───────────────────────────────────────────────────────────────
export default function AboutPage() {
  return (
    <main>
      <OurHistory />
      <Vision />
      <Mission />
      <PersonalQuote />
    </main>
  );
}

